import { render, staticRenderFns } from "./MediaPreviewButton.vue?vue&type=template&id=b992c05e"
import script from "./MediaPreviewButton.vue?vue&type=script&lang=js"
export * from "./MediaPreviewButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports